import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import Api from '@/services/api';
import type { BaseContext } from '@/types';
import type { RosaReportImage } from '@/types/entities/Rosa';

type CreateUrlSignedError = AxiosError<any>;

export type CreateUrlSignedResponse = {
	url: string;
	report_image: RosaReportImage;
};

export type CreateUrlSignedRequest = BaseContext & {
	report_id: string;
	file_name: string;
	size_number: number;
	content_type: string;
};

async function createUrlSigned(params: CreateUrlSignedRequest): Promise<CreateUrlSignedResponse> {
	const url = `/ergonomic-tool/rosa/upload-url-signed/${params.report_id}`;
	const { data } = await Api.post<CreateUrlSignedResponse>(url, params);
	return data;
}

export const useCreateUrlSigned = () => {
	return useMutation<CreateUrlSignedResponse, CreateUrlSignedError, CreateUrlSignedRequest>(
		(body: CreateUrlSignedRequest) => createUrlSigned(body),
		{
			onError: (err: any) => {
				notification.error({
					message: I18n.get(err?.response?.data?.message || 'Ops... something happened!')
				});
			}
		}
	);
};
